import { formatUSD, truncateToFullChar } from "@/utils";
import { useState } from "react";
import Image from "next/image";

const MobileRankRow = ({ globalRank, record, t, uuid }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="relative py-4 text-white">
      {/* 小三角按钮 */}
      <button
        onClick={() => setExpanded(!expanded)}
        className="absolute right-4 top-6 z-10 flex h-6 w-6 items-center justify-center"
      >
        <div
          className={`h-0 w-0 border-l-[6px] border-r-[6px] border-t-[6px] border-l-transparent 
                border-r-transparent border-t-white transition-transform duration-300 ${expanded ? "rotate-180" : ""}`}
        />
      </button>
      {/* 顶部信息 */}
      <div className="flex items-center gap-4 pr-8">
        {globalRank <= 3 ? (
          <div className="relative ml-2 h-[48px] w-[38px]">
            <Image
              src={`/images/csr/rank_${globalRank}.webp`}
              alt={`Rank ${globalRank}`}
              fill
              className="object-contain"
            />
          </div>
        ) : (
          <span className="w-12 text-center text-3xl font-semibold text-[#ffc107]">{globalRank}</span>
        )}
        <span className="overflow-hidden whitespace-nowrap text-2xl font-semibold" title={record.name}>
          {truncateToFullChar(record.name, 16)}
        </span>
        {uuid === record.uuid && (
          <span className="w-10 rounded-xl bg-[#efff04] py-[2px] text-center text-sm text-stone-800">
            {t("csr.current_user")}
          </span>
        )}
      </div>

      {/* 折叠内容 */}
      {expanded && (
        <div className="text-black mt-4 rounded-xl bg-stone-300 p-4 text-sm">
          <div className="mb-2">
            <span className="mr-4 min-w-[72px] text-[#9ca3af]">{t("csr.ib_investment_donation")}</span>
            <span>{formatUSD(record?.sumTotalTradingDonationAmountUsd)} USD</span>
          </div>
          <div className="mb-2">
            <span className="mr-4 min-w-[72px] text-[#9ca3af]">{t("csr.ib_dream_donation")}</span>
            <span>{formatUSD(record?.sumTotalDreamPointsDonationAmountUsd)} USD</span>
          </div>
          <div>
            <span className="mr-4 min-w-[72px] text-[#9ca3af]">{t("csr.donation_total")}</span>
            <span>{formatUSD(record?.sumTotalDonationAmountUsd)} USD</span>
          </div>
        </div>
      )}
    </div>
  );
};
export default MobileRankRow;
